import React from 'react';
import { LinearProgress, Typography, Box, useTheme } from '@mui/material';

// TranslationProgress component
const TranslationProgress = ({
  currentProgress,
}) => {
  const theme = useTheme();
  return (
    <Box sx={{
      width: '300px',
      backgroundColor: theme.palette.background.paper,
      padding: 2,
      borderRadius: 2,
    }}>
      <LinearProgress
        variant="determinate"
        value={currentProgress.progress}
        sx={{
          height: 6,
          borderRadius: 2,
          backgroundColor: 'rgba(0,0,0,0.1)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
          }
        }}
      />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 1, textAlign: 'center' }}
      >
        {Math.round(currentProgress.progress)}%
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1, textAlign: 'center' }}
      >
        {currentProgress.message}
      </Typography>
    </Box>
  );
};

export default TranslationProgress;